/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import {Zeropoint} from "App/zero_point";

export default
class ZeropointSettings {

    private _modelDescription: Description;
    public zeropoint: Zeropoint;

    constructor(aModelDescription: Description) {
        this._modelDescription = aModelDescription;

        // default values
        this.zeropoint = new Zeropoint();
    }

    public parse(aModelDescriptionJSON: any): boolean {
        if (!aModelDescriptionJSON.hasOwnProperty("ZeropointSettings")) {
            return false;
        }

        this.zeropoint.set(aModelDescriptionJSON.ZeropointSettings.translationMat, aModelDescriptionJSON.ZeropointSettings.rotation);

        return true;
    }

    public getJSONRepresentation(): any {
        return {
            translationMat: this.zeropoint.getTranslationMat(),
            rotation: this.zeropoint.getRotation()
        };
    }
}